import { createSelector } from 'reselect'

const quiz_questions_changed_selector = createSelector(
	[ state => state.quiz ],
	quizState => quizState.questions.filter(question => question.status === 'changed')
)

export default quiz_questions_changed_selector
